var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
/* istanbul ignore file */
/* tslint:disable: cyclomatic-complexity */
/* tslint:disable: no-non-null-assertion */
import * as React from "react";
import * as CMP from "../JackpotItem";
import { Popup, PopupupMessageComponents, PopupMessage, FreeHtml, PopupMessageTypeClasses } from "sb-resp-ui";
import { DeviceDetect } from "sb-resp-utils";
import { observer } from "mobx-react";
import { tickerPopupDesktopConfigOverrides, tickerPopupMobileConfigOverrides } from "../Ticker";
import { observable, computed } from "mobx";
import { JackpotPopupButton } from "../JackpotPopupButton";
let JackpotPopup = class JackpotPopup extends React.Component {
    constructor(props) {
        super(props);
        this.deviceDetect = DeviceDetect.getInstance();
        this.refCloseBtn = React.createRef();
        this.refPopup = React.createRef();
        this.refScrollContainer = React.createRef();
        this.refPopupHeader = React.createRef();
        this.refPopupButton = React.createRef();
        this.isStyledCloseBtn = false;
        this.renderPopup = this.renderPopup.bind(this);
        this.setPopupPanelOpen = this.setPopupPanelOpen.bind(this);
        this.activateScrollingListener = this.activateScrollingListener.bind(this);
        this.renderAlternativeStyledCloseBtn = this.renderAlternativeStyledCloseBtn.bind(this);
        this.activateListenTouch = this.activateListenTouch.bind(this);
    }
    activateScrollbar() {
        if (this.deviceDetect.isDesktop) {
            this.customScroll = new window["CustomScrollbar"](this.refScrollContainer.current, true);
        }
    }
    activateScrollingListener() {
        if (this.deviceDetect.isMobile && this.refPopup.current) {
            this.refPopup.current.addEventListener("scroll", (event) => {
                if (this.refPopupHeader.current) {
                    this.styledClosedBtnlistenHadnler(event);
                    this.fixedBtnListenHandler(event);
                }
            });
        }
    }
    styledClosedBtnlistenHadnler(event) {
        if (this.refCloseBtn.current &&
            event.target.scrollTop > this.refPopupHeader.current.offsetHeight - this.refCloseBtn.current.clientHeight) {
            this.isStyledCloseBtn = true;
        }
        else {
            this.isStyledCloseBtn = false;
        }
    }
    fixedBtnListenHandler(event) {
        if (this.refScrollContainer.current &&
            this.refPopupButton.current &&
            event.target.scrollTop > this.refPopupHeader.current.offsetHeight +
                this.refPopupButton.current.offsetHeight + this.convertPaddingTopToNumber(window.getComputedStyle(this.refScrollContainer.current).paddingTop)) {
            this.props.jackpot.showBottomLinkBtn = true;
        }
        else {
            this.props.jackpot.showBottomLinkBtn = false;
        }
    }
    convertPaddingTopToNumber(paddingTop) {
        if (paddingTop) {
            return parseInt(paddingTop.replace("px", ""));
        }
        return 0;
    }
    get scrollableBodyClass() {
        let fixedClass = "scrollable-wrapper";
        if (this.props.jackpot.showPopupBtn) {
            fixedClass += " scrollable-wrapper-spacing-top";
            if (this.props.jackpot.showBottomLinkBtn) {
                fixedClass += " scrollable-wrapper-spacing-bottom";
            }
        }
        return fixedClass;
    }
    activateListenTouch(jackpot) {
        const popupOverlay = document.querySelector(".rj-popup-portal.rj-popup-jackpot");
        const popupContent = this.refPopup.current;
        if (popupOverlay && popupContent) {
            if (this.deviceDetect.isDesktop) {
                popupOverlay.addEventListener("click", (event) => {
                    event.stopPropagation();
                    jackpot.closePopup();
                });
                popupContent.addEventListener("click", (event) => {
                    if (event.srcElement !== this.refPopupButton.current) {
                        event.stopPropagation();
                    }
                });
            }
            else {
                popupOverlay.addEventListener("touchstart", (event) => {
                    event.preventDefault();
                    jackpot.closePopup();
                });
                popupContent.addEventListener("touchstart", (event) => event.stopPropagation());
            }
        }
    }
    renderPopup(jackpot, isUserLoggedIn) {
        const config = {
            className: "rj-popup-jackpot",
            isInIframe: false,
            hasCloseBtn: false,
            beforeHideCallback: () => {
                jackpot.closePopup();
                this.setPopupPanelOpen(false);
            },
            afterShowCallback: () => {
                this.setPopupPanelOpen(true);
                this.activateScrollbar();
                this.activateScrollingListener();
                this.activateListenTouch(jackpot);
            }
        };
        const msgConfigContent = {
            closeBtn: false,
            type: PopupMessageTypeClasses.dialog,
            className: "rj-jackpot-popup-message",
            actions: {}
        };
        const configOverrides = this.deviceDetect.isMobile
            ? tickerPopupMobileConfigOverrides
            : tickerPopupDesktopConfigOverrides;
        const scrollableStyles = this.deviceDetect.isTablet
            ? { overflow: "auto" }
            : {};
        const popupMessageBodyClass = jackpot.showPopupBtn
            ? "rj-jackpot-popup-message__body rj-jackpot-popup-message__body_with-btn scrollable"
            : "rj-jackpot-popup-message__body scrollable";
        return (React.createElement("div", { className: "rj-jackpot-popup-wrapper" },
            React.createElement(Popup, { config: config },
                this.renderAlternativeStyledCloseBtn(jackpot),
                jackpot.showPopupBtn && React.createElement(JackpotPopupButton, { buttonName: jackpot.getPopupButtonName(isUserLoggedIn), buttonLink: jackpot.getPopupButtonLink(isUserLoggedIn, this.deviceDetect.isDesktop), inputRef: this.refPopupButton, isSticky: true, showBottomLinkBtn: jackpot.showBottomLinkBtn }),
                React.createElement(PopupMessage, { config: msgConfigContent },
                    React.createElement("div", { id: "rj-jackpot-popup-msg-body", className: "rj-jackpot-popup-message__wrapper", style: { overflow: "auto" }, ref: this.refPopup },
                        React.createElement(PopupupMessageComponents.Body, { actions: msgConfigContent.actions },
                            React.createElement("div", { className: "rj-jackpot-popup-message__header-wrapper" },
                                React.createElement("div", { className: "rj-jackpot-popup-message__header", ref: this.refPopupHeader },
                                    React.createElement(CMP.JackpotItem, { jackpot: jackpot, tickerConfig: configOverrides, datePartConfig: { hideLearnMoreBtn: true } }))),
                            React.createElement("div", { className: popupMessageBodyClass, ref: this.refScrollContainer, style: scrollableStyles },
                                jackpot.showPopupBtn && React.createElement(JackpotPopupButton, { buttonName: jackpot.getPopupButtonName(isUserLoggedIn), buttonLink: jackpot.getPopupButtonLink(isUserLoggedIn, this.deviceDetect.isDesktop), inputRef: this.refPopupButton, isSticky: false, showBottomLinkBtn: jackpot.showBottomLinkBtn }),
                                React.createElement("div", { className: this.scrollableBodyClass },
                                    React.createElement("div", { className: "rj-jackpot-free-html" },
                                        React.createElement(FreeHtml, { html: jackpot.Description })),
                                    React.createElement("div", { className: "rj-jackpot-terms" },
                                        !!jackpot.termsHeader && (React.createElement("div", { className: "rj-jackpot-terms__header" },
                                            React.createElement("h4", { className: "rj-jackpot-terms__header-title" }, jackpot.termsHeader))),
                                        !!jackpot.terms && (React.createElement("div", { className: "rj-jackpot-terms__body" },
                                            React.createElement("span", null,
                                                React.createElement(FreeHtml, { html: jackpot.terms })))))))))))));
    }
    renderAlternativeStyledCloseBtn(jackpot) {
        const closeBtnClass = this.isStyledCloseBtn ? "rj-popup-message__close-btn--alternative" : "";
        return (React.createElement("div", { className: `rj-popup-message__close-btn ${closeBtnClass}`, ref: this.refCloseBtn, onClick: () => jackpot.closePopup() },
            React.createElement("span", { className: "icon i-14 i-o-controls-close" })));
    }
    setPopupPanelOpen(show) {
        if (show) {
            document.body.classList.add("jackpot-popup-open");
        }
        else {
            document.body.classList.remove("jackpot-popup-open");
        }
    }
    render() {
        let { jackpot, isUserLoggedIn } = this.props;
        return this.renderPopup(jackpot, isUserLoggedIn);
    }
};
__decorate([
    observable,
    __metadata("design:type", Boolean)
], JackpotPopup.prototype, "isStyledCloseBtn", void 0);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], JackpotPopup.prototype, "scrollableBodyClass", null);
JackpotPopup = __decorate([
    observer,
    __metadata("design:paramtypes", [Object])
], JackpotPopup);
export { JackpotPopup };
//# sourceMappingURL=JackpotPopup.js.map